module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Front"
    }
  }, [_c('p', {
    staticClass: "front-para"
  }, [_vm._v("… Though much is taken, much abides; and though"), _c('br'), _vm._v("We are not now that strength which in the old days"), _c('br'), _vm._v("Moved earth and heaven, that which we are, we are,"), _c('br'), _vm._v("One equal temper of heroic hearts,"), _c('br'), _vm._v("Made weak by time and fate, but strong in will"), _c('br'), _vm._v("To strive, to seek, to find, and not to yield.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Alfred Lord Tennyson, "), _c('i', [_vm._v("Ulysses")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68e3c76a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Front.vue
// module id = 57
// module chunks = 0